import {
	VERIFY_EMAIL_FAILED,
	VERIFY_EMAIL_SUCCESSFULLY,
} from '../Actions/types';

const INITIAL_STATE = {
	data: {},
	error: {}
}

const emailReducer = (state = INITIAL_STATE, action) => {
	switch (action.type) {
		case VERIFY_EMAIL_SUCCESSFULLY: 
    		return {...state, data: action.payload }
		case VERIFY_EMAIL_FAILED: 
    		return {...state, error: action.payload }
		default:
			return {...INITIAL_STATE}
	}
}

export default emailReducer;